// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__dTf11","logo":"Header_logo__shVBB","active":"Header_active__OcOMM"};